import React from 'react';

import { ThemeType } from '.';

const ThemeTypeContext = React.createContext<{ themeType?: ThemeType }>({});

export const ThemeTypeProvider = ThemeTypeContext.Provider;

export function useThemeType() {
    const context = React.useContext(ThemeTypeContext);

    if (context === undefined) {
        throw new Error('useThemeType must be used within a ThemeTypeProvider');
    }

    return context.themeType;
}
